/**
 * A simple to implement and integrate Angular image carousel, built with sensible CSS.
 * @version v0.1.1 - 2015-01-20
 * @link https://github.com/forwardadvance/higgidy_carousel
 * @author Nicholas Johnson - nicholas@forwardadvance.com
 * @license MIT License, http://www.opensource.org/licenses/MIT
 */
"use strict";

var cov_19x8qiynr8 = function () {
  var path = 'D:\\freelance\\giutien-viettel\\client-giutien\\src\\js\\higgidy_carousel.js',
      hash = 'e78d5697958e8c5fd59710078ed6a0d995ec3d55',
      global = new Function('return this')(),
      gcv = '__coverage__',
      coverageData = {
    path: 'D:\\freelance\\giutien-viettel\\client-giutien\\src\\js\\higgidy_carousel.js',
    statementMap: {
      '0': {
        start: {
          line: 10,
          column: 0
        },
        end: {
          line: 86,
          column: 5
        }
      },
      '1': {
        start: {
          line: 14,
          column: 4
        },
        end: {
          line: 17,
          column: 6
        }
      },
      '2': {
        start: {
          line: 18,
          column: 4
        },
        end: {
          line: 24,
          column: 6
        }
      },
      '3': {
        start: {
          line: 19,
          column: 6
        },
        end: {
          line: 23,
          column: 7
        }
      },
      '4': {
        start: {
          line: 20,
          column: 8
        },
        end: {
          line: 20,
          column: 51
        }
      },
      '5': {
        start: {
          line: 22,
          column: 8
        },
        end: {
          line: 22,
          column: 32
        }
      },
      '6': {
        start: {
          line: 25,
          column: 4
        },
        end: {
          line: 28,
          column: 6
        }
      },
      '7': {
        start: {
          line: 26,
          column: 6
        },
        end: {
          line: 26,
          column: 28
        }
      },
      '8': {
        start: {
          line: 27,
          column: 6
        },
        end: {
          line: 27,
          column: 34
        }
      },
      '9': {
        start: {
          line: 29,
          column: 4
        },
        end: {
          line: 34,
          column: 6
        }
      },
      '10': {
        start: {
          line: 30,
          column: 6
        },
        end: {
          line: 30,
          column: 32
        }
      },
      '11': {
        start: {
          line: 31,
          column: 6
        },
        end: {
          line: 33,
          column: 7
        }
      },
      '12': {
        start: {
          line: 32,
          column: 8
        },
        end: {
          line: 32,
          column: 36
        }
      },
      '13': {
        start: {
          line: 35,
          column: 4
        },
        end: {
          line: 37,
          column: 6
        }
      },
      '14': {
        start: {
          line: 36,
          column: 6
        },
        end: {
          line: 36,
          column: 66
        }
      },
      '15': {
        start: {
          line: 38,
          column: 4
        },
        end: {
          line: 41,
          column: 6
        }
      },
      '16': {
        start: {
          line: 39,
          column: 6
        },
        end: {
          line: 39,
          column: 32
        }
      },
      '17': {
        start: {
          line: 40,
          column: 6
        },
        end: {
          line: 40,
          column: 27
        }
      },
      '18': {
        start: {
          line: 42,
          column: 4
        },
        end: {
          line: 42,
          column: 58
        }
      },
      '19': {
        start: {
          line: 43,
          column: 4
        },
        end: {
          line: 43,
          column: 43
        }
      },
      '20': {
        start: {
          line: 47,
          column: 20
        },
        end: {
          line: 59,
          column: 5
        }
      },
      '21': {
        start: {
          line: 52,
          column: 10
        },
        end: {
          line: 52,
          column: 56
        }
      },
      '22': {
        start: {
          line: 53,
          column: 10
        },
        end: {
          line: 55,
          column: 12
        }
      },
      '23': {
        start: {
          line: 54,
          column: 12
        },
        end: {
          line: 54,
          column: 58
        }
      },
      '24': {
        start: {
          line: 56,
          column: 10
        },
        end: {
          line: 56,
          column: 57
        }
      },
      '25': {
        start: {
          line: 60,
          column: 4
        },
        end: {
          line: 60,
          column: 21
        }
      },
      '26': {
        start: {
          line: 64,
          column: 20
        },
        end: {
          line: 84,
          column: 5
        }
      },
      '27': {
        start: {
          line: 68,
          column: 10
        },
        end: {
          line: 76,
          column: 12
        }
      },
      '28': {
        start: {
          line: 69,
          column: 29
        },
        end: {
          line: 69,
          column: 70
        }
      },
      '29': {
        start: {
          line: 70,
          column: 12
        },
        end: {
          line: 72,
          column: 15
        }
      },
      '30': {
        start: {
          line: 73,
          column: 12
        },
        end: {
          line: 75,
          column: 15
        }
      },
      '31': {
        start: {
          line: 77,
          column: 10
        },
        end: {
          line: 79,
          column: 12
        }
      },
      '32': {
        start: {
          line: 78,
          column: 12
        },
        end: {
          line: 78,
          column: 98
        }
      },
      '33': {
        start: {
          line: 80,
          column: 10
        },
        end: {
          line: 80,
          column: 57
        }
      },
      '34': {
        start: {
          line: 81,
          column: 10
        },
        end: {
          line: 81,
          column: 64
        }
      },
      '35': {
        start: {
          line: 85,
          column: 4
        },
        end: {
          line: 85,
          column: 21
        }
      }
    },
    fnMap: {
      '0': {
        name: '(anonymous_0)',
        decl: {
          start: {
            line: 12,
            column: 68
          },
          end: {
            line: 12,
            column: 69
          }
        },
        loc: {
          start: {
            line: 12,
            column: 96
          },
          end: {
            line: 44,
            column: 3
          }
        },
        line: 12
      },
      '1': {
        name: '(anonymous_1)',
        decl: {
          start: {
            line: 18,
            column: 20
          },
          end: {
            line: 18,
            column: 21
          }
        },
        loc: {
          start: {
            line: 18,
            column: 31
          },
          end: {
            line: 24,
            column: 5
          }
        },
        line: 18
      },
      '2': {
        name: '(anonymous_2)',
        decl: {
          start: {
            line: 25,
            column: 18
          },
          end: {
            line: 25,
            column: 19
          }
        },
        loc: {
          start: {
            line: 25,
            column: 30
          },
          end: {
            line: 28,
            column: 5
          }
        },
        line: 25
      },
      '3': {
        name: '(anonymous_3)',
        decl: {
          start: {
            line: 29,
            column: 20
          },
          end: {
            line: 29,
            column: 21
          }
        },
        loc: {
          start: {
            line: 29,
            column: 31
          },
          end: {
            line: 34,
            column: 5
          }
        },
        line: 29
      },
      '4': {
        name: '(anonymous_4)',
        decl: {
          start: {
            line: 35,
            column: 25
          },
          end: {
            line: 35,
            column: 26
          }
        },
        loc: {
          start: {
            line: 35,
            column: 36
          },
          end: {
            line: 37,
            column: 5
          }
        },
        line: 35
      },
      '5': {
        name: '(anonymous_5)',
        decl: {
          start: {
            line: 38,
            column: 26
          },
          end: {
            line: 38,
            column: 27
          }
        },
        loc: {
          start: {
            line: 38,
            column: 37
          },
          end: {
            line: 41,
            column: 5
          }
        },
        line: 38
      },
      '6': {
        name: '(anonymous_6)',
        decl: {
          start: {
            line: 46,
            column: 32
          },
          end: {
            line: 46,
            column: 33
          }
        },
        loc: {
          start: {
            line: 46,
            column: 43
          },
          end: {
            line: 61,
            column: 3
          }
        },
        line: 46
      },
      '7': {
        name: '(anonymous_7)',
        decl: {
          start: {
            line: 51,
            column: 12
          },
          end: {
            line: 51,
            column: 13
          }
        },
        loc: {
          start: {
            line: 51,
            column: 44
          },
          end: {
            line: 57,
            column: 9
          }
        },
        line: 51
      },
      '8': {
        name: '(anonymous_8)',
        decl: {
          start: {
            line: 53,
            column: 27
          },
          end: {
            line: 53,
            column: 28
          }
        },
        loc: {
          start: {
            line: 53,
            column: 38
          },
          end: {
            line: 55,
            column: 11
          }
        },
        line: 53
      },
      '9': {
        name: '(anonymous_9)',
        decl: {
          start: {
            line: 63,
            column: 38
          },
          end: {
            line: 63,
            column: 39
          }
        },
        loc: {
          start: {
            line: 63,
            column: 49
          },
          end: {
            line: 86,
            column: 3
          }
        },
        line: 63
      },
      '10': {
        name: '(anonymous_10)',
        decl: {
          start: {
            line: 67,
            column: 14
          },
          end: {
            line: 67,
            column: 15
          }
        },
        loc: {
          start: {
            line: 67,
            column: 39
          },
          end: {
            line: 82,
            column: 9
          }
        },
        line: 67
      },
      '11': {
        name: '(anonymous_11)',
        decl: {
          start: {
            line: 68,
            column: 29
          },
          end: {
            line: 68,
            column: 30
          }
        },
        loc: {
          start: {
            line: 68,
            column: 40
          },
          end: {
            line: 76,
            column: 11
          }
        },
        line: 68
      },
      '12': {
        name: '(anonymous_12)',
        decl: {
          start: {
            line: 77,
            column: 32
          },
          end: {
            line: 77,
            column: 33
          }
        },
        loc: {
          start: {
            line: 77,
            column: 43
          },
          end: {
            line: 79,
            column: 11
          }
        },
        line: 77
      }
    },
    branchMap: {
      '0': {
        loc: {
          start: {
            line: 19,
            column: 6
          },
          end: {
            line: 23,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 19,
            column: 6
          },
          end: {
            line: 23,
            column: 7
          }
        }, {
          start: {
            line: 19,
            column: 6
          },
          end: {
            line: 23,
            column: 7
          }
        }],
        line: 19
      },
      '1': {
        loc: {
          start: {
            line: 31,
            column: 6
          },
          end: {
            line: 33,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 31,
            column: 6
          },
          end: {
            line: 33,
            column: 7
          }
        }, {
          start: {
            line: 31,
            column: 6
          },
          end: {
            line: 33,
            column: 7
          }
        }],
        line: 31
      },
      '2': {
        loc: {
          start: {
            line: 56,
            column: 35
          },
          end: {
            line: 56,
            column: 56
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 56,
            column: 35
          },
          end: {
            line: 56,
            column: 48
          }
        }, {
          start: {
            line: 56,
            column: 52
          },
          end: {
            line: 56,
            column: 56
          }
        }],
        line: 56
      }
    },
    s: {
      '0': 0,
      '1': 0,
      '2': 0,
      '3': 0,
      '4': 0,
      '5': 0,
      '6': 0,
      '7': 0,
      '8': 0,
      '9': 0,
      '10': 0,
      '11': 0,
      '12': 0,
      '13': 0,
      '14': 0,
      '15': 0,
      '16': 0,
      '17': 0,
      '18': 0,
      '19': 0,
      '20': 0,
      '21': 0,
      '22': 0,
      '23': 0,
      '24': 0,
      '25': 0,
      '26': 0,
      '27': 0,
      '28': 0,
      '29': 0,
      '30': 0,
      '31': 0,
      '32': 0,
      '33': 0,
      '34': 0,
      '35': 0
    },
    f: {
      '0': 0,
      '1': 0,
      '2': 0,
      '3': 0,
      '4': 0,
      '5': 0,
      '6': 0,
      '7': 0,
      '8': 0,
      '9': 0,
      '10': 0,
      '11': 0,
      '12': 0
    },
    b: {
      '0': [0, 0],
      '1': [0, 0],
      '2': [0, 0]
    },
    _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

++cov_19x8qiynr8.s[0];
angular.module('HiggidyCarousel', []).controller('HiggidyCarousel.controller', ["$scope", "$interval", function ($scope, $interval) {
  ++cov_19x8qiynr8.f[0];

  var timeout;
  ++cov_19x8qiynr8.s[1];
  $scope.carousel = {
    current: 0,
    max: 0
  };
  ++cov_19x8qiynr8.s[2];
  $scope.setMax = function () {
    ++cov_19x8qiynr8.f[1];
    ++cov_19x8qiynr8.s[3];

    if ($scope.images) {
      ++cov_19x8qiynr8.b[0][0];
      ++cov_19x8qiynr8.s[4];

      $scope.carousel.max = $scope.images.length;
    } else {
      ++cov_19x8qiynr8.b[0][1];
      ++cov_19x8qiynr8.s[5];

      $scope.carousel.max = 1;
    }
  };
  ++cov_19x8qiynr8.s[6];
  $scope.show = function (i) {
    ++cov_19x8qiynr8.f[2];
    ++cov_19x8qiynr8.s[7];

    $scope.resetTimeout();
    ++cov_19x8qiynr8.s[8];
    $scope.carousel.current = i;
  };
  ++cov_19x8qiynr8.s[9];
  $scope.moveOn = function () {
    ++cov_19x8qiynr8.f[3];
    ++cov_19x8qiynr8.s[10];

    $scope.carousel.current++;
    ++cov_19x8qiynr8.s[11];
    if ($scope.carousel.current >= $scope.carousel.max) {
      ++cov_19x8qiynr8.b[1][0];
      ++cov_19x8qiynr8.s[12];

      $scope.carousel.current = 0;
    } else {
      ++cov_19x8qiynr8.b[1][1];
    }
  };
  ++cov_19x8qiynr8.s[13];
  $scope.initTimeout = function () {
    ++cov_19x8qiynr8.f[4];
    ++cov_19x8qiynr8.s[14];

    timeout = $interval($scope.moveOn, $scope.carousel.timeout);
  };
  ++cov_19x8qiynr8.s[15];
  $scope.resetTimeout = function () {
    ++cov_19x8qiynr8.f[5];
    ++cov_19x8qiynr8.s[16];

    $interval.cancel(timeout);
    ++cov_19x8qiynr8.s[17];
    $scope.initTimeout();
  };
  ++cov_19x8qiynr8.s[18];
  $scope.$watch('carousel.timeout', $scope.initTimeout);
  ++cov_19x8qiynr8.s[19];
  $scope.$watch('images', $scope.setMax);
}]).directive('higgidyCarousel', function () {
  ++cov_19x8qiynr8.f[6];

  var directive = (++cov_19x8qiynr8.s[20], {
    controller: 'HiggidyCarousel.controller',
    scope: true,
    link: {
      pre: function pre(scope, element, attrs) {
        ++cov_19x8qiynr8.f[7];
        ++cov_19x8qiynr8.s[21];

        scope.carousel.width = element[0].offsetWidth;
        ++cov_19x8qiynr8.s[22];
        scope.getWidth = function () {
          ++cov_19x8qiynr8.f[8];
          ++cov_19x8qiynr8.s[23];

          scope.carousel.width = element[0].offsetWidth;
        };
        ++cov_19x8qiynr8.s[24];
        scope.carousel.timeout = (++cov_19x8qiynr8.b[2][0], attrs.timeout) || (++cov_19x8qiynr8.b[2][1], 1000);
      }
    }
  });
  ++cov_19x8qiynr8.s[25];
  return directive;
}).directive('higgidyCarouselImages', function () {
  ++cov_19x8qiynr8.f[9];

  var directive = (++cov_19x8qiynr8.s[26], {
    scope: true,
    link: {
      post: function post(scope, element) {
        ++cov_19x8qiynr8.f[10];
        ++cov_19x8qiynr8.s[27];

        scope.setsWidths = function () {
          ++cov_19x8qiynr8.f[11];

          var totalWidth = (++cov_19x8qiynr8.s[28], scope.carousel.width * scope.carousel.max);
          ++cov_19x8qiynr8.s[29];
          element.find('img').css({
            width: scope.carousel.width + 'px'
          });
          ++cov_19x8qiynr8.s[30];
          element.css({
            width: totalWidth + 'px'
          });
        };
        ++cov_19x8qiynr8.s[31];
        scope.animateScroll = function () {
          ++cov_19x8qiynr8.f[12];
          ++cov_19x8qiynr8.s[32];

          element.css({ 'margin-left': 0 - scope.carousel.width * scope.carousel.current + "px" });
        };
        ++cov_19x8qiynr8.s[33];
        scope.$watch('carousel.max', scope.setsWidths);
        ++cov_19x8qiynr8.s[34];
        scope.$watch('carousel.current', scope.animateScroll);
      }
    }
  });
  ++cov_19x8qiynr8.s[35];
  return directive;
});